import { Navigate, useLocation } from "react-router-dom";

/**
 * `/app/*` → `/studio/*`, preserving the sub-path, query string and hash.
 * The workspace has always been served from `/studio`; `/app` links exist in
 * older emails, docs and bookmarks.
 */
export function LegacyStudioRedirect() {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/app/, "");
  return <Navigate to={`/studio${rest}${search}${hash}`} replace />;
}
